module.exports = __webpack_public_path__ + "img/trash-can-solid.96483bc7.svg";